import React from 'react';
import { ItemRequiredText } from '../../../components/Item';
import { useField } from 'react-final-form';

const isEqual = (a: any, b: any) => {
  if (a === b) {
    return true;
  }

  if (!a && !b) {
    return true;
  }

  if (Array.isArray(a) && Array.isArray(b) && a.length === b.length) {
    return a.reduce((agg, curr, i) => agg && curr === b[i], true);
  }

  if (Array.isArray(a) && a.length === 1) return a[0] === b;
  if (Array.isArray(b) && b.length === 1) return a === b[0];

  return false;
};

// is Equal has to be replied to make sure it does override isEqual else where
const ErrorField = ({ name }: { name: string }) => {
  const field = useField(name, {
    isEqual: isEqual,
    subscription: { error: true },
  });
  return <ItemRequiredText error={field.meta.error} />;
};

export default ErrorField;
